import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class StateService {

	currentLoginEmail?: string;
	currentRegisterEmail?: string;

	agreeToTermsAndConditions?: boolean;
	
	currentFirstName?: string;
	currentLastName?: string;

	constructor() { }

}
